const ADMIN_IS_SUPER = true;

const LICENSES = {
    FISH_HEALTH: {
        MIN: '^FISH_HEALTH\\.MIN$',
        INSPECTION: '^FISH_HEALTH\\.INSPECTION$',
    },
    LICE_COUNT: {
        MIN: '^LICE_COUNT\\.MIN$',
        MAX: '^LICE_COUNT\\.MAX$',
    },
    LAKSVEL: '^LAKSVEL$',
    FISH_SPEED: '^FISH_SPEED$',
    LIVE_VIDEO_STREAM: '^LIVE_VIDEO_STREAM$',
    BIOMASS_WITH_QUALITY: '^BIOMASS_WITH_QUALITY$',
    BEHAVIOR: '^BEHAVIOR$',
};

// Keep updated with the licenses table in the database
const LICENSE_CODES = {
    FISH_HEALTH: {
        MIN: 'FISH_HEALTH.MIN',
        INSPECTION: 'FISH_HEALTH.INSPECTION',
    },
    LICE_COUNT: {
        MIN: 'LICE_COUNT.MIN',
        MAX: 'LICE_COUNT.MAX',
    },
    LAKSVEL: 'LAKSVEL',
    FISH_SPEED: 'FISH_SPEED',
    LIVE_VIDEO_STREAM: 'LIVE_VIDEO_STREAM',
    BIOMASS_WITH_QUALITY: 'BIOMASS_WITH_QUALITY',
    BEHAVIOR: 'BEHAVIOR',
} as const;

// Type for all possible license codes
type LicenseCode =
    | typeof LICENSE_CODES.FISH_HEALTH.MIN
    | typeof LICENSE_CODES.FISH_HEALTH.INSPECTION
    | typeof LICENSE_CODES.LICE_COUNT.MIN
    | typeof LICENSE_CODES.LICE_COUNT.MAX
    | typeof LICENSE_CODES.LAKSVEL
    | typeof LICENSE_CODES.FISH_SPEED
    | typeof LICENSE_CODES.LIVE_VIDEO_STREAM
    | typeof LICENSE_CODES.BIOMASS_WITH_QUALITY
    | typeof LICENSE_CODES.BEHAVIOR;

/**
 * Location-level license keys — derived from the Licenses interface
 * returned by useLicenseController_getLocationsLicense.
 * Each key maps to a { hasValidLicense } boolean on the response.
 */
type LocationLicenseKey =
    | 'behaviorLicense'
    | 'biomassLicense'
    | 'fishHealthLicense'
    | 'fishSpeedLicense'
    | 'laksvelLicense'
    | 'liceLicense'
    | 'liveStreamLicense';

/**
 * Union of all license key formats used in sidebar config:
 * - LocationLicenseKey: for location-level items (e.g. 'liceLicense')
 * - LicenseCode: for cage-level items (e.g. 'LICE_COUNT.MIN')
 */
type SidebarLicenseKey = LicenseCode | LocationLicenseKey;

export default LICENSES;

export type { LicenseCode, LocationLicenseKey, SidebarLicenseKey };
export { ADMIN_IS_SUPER, LICENSE_CODES, LICENSES };
